import { BASE_URL, authHeader } from '../integrations/APIClient';

// A linked Static Web App backend can serve /api on the site origin. If that
// link is missing, the site may serve index.html (HTTP 200) for /api URLs.
// Fall back only to our own, known Azure Functions host in that situation.
const AZURE_FUNCTIONS_ORIGIN = 'https://chesshoodbackend.azurewebsites.net';
export const trainingApiOrigins = [...new Set(
  [BASE_URL, AZURE_FUNCTIONS_ORIGIN]
    .map((origin) => String(origin || '').trim().replace(/[/]+$/, ''))
    .filter(Boolean)
)];

export const sessionIdFromUrl = () => new URLSearchParams(window.location.search).get('session') || '';
export const sessionPath = (mode, id = '') => `${['hood', 'lichess'].includes(mode) ? '/hood-ai' : '/play'}${id ? `?session=${encodeURIComponent(id)}` : ''}`;

function isRouteMissing(response, body, path) {
  if (response.status === 404 || response.status === 405) return true;
  if (!response.ok) return false;
  const contentType = (response.headers.get('content-type') || '').toLowerCase();
  if (contentType.includes('text/html')) return true;
  if (!body || typeof body !== 'object' || Array.isArray(body)) return true;
  const route = path.split('?')[0];
  if (route === 'catalog' && !Array.isArray(body.plans)) return true;
  if (route === 'sessions' && !Array.isArray(body.sessions)) return true;
  return false;
}

export async function trainingRequest(path, { body, sessionId, signal } = {}) {
  const headers = await authHeader();
  if (body) headers.set('Content-Type', 'application/json');
  if (sessionId) headers.set('X-Training-Session', sessionId);
  let lastError;
  for (let index = 0; index < trainingApiOrigins.length; index += 1) {
    const endpoint = `${trainingApiOrigins[index]}/api/training-payments/${path}`;
    let result;
    try {
      result = await fetch(endpoint, {
        method: body ? 'POST' : 'GET',
        headers,
        body: body ? JSON.stringify(body) : undefined,
        signal,
      });
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      // GET requests can be retried on the alternative trusted API host.
      // For writes, do not retry ambiguous network errors after a server may
      // have processed the original request.
      lastError = error;
      if (!body && index < trainingApiOrigins.length - 1) continue;
      throw error;
    }
    const raw = await result.text();
    let data;
    try { data = raw ? JSON.parse(raw) : null; } catch { data = null; }
    if (isRouteMissing(result, data, path)) {
      lastError = new Error('training_api_route_unavailable');
      lastError.status = result.status;
      if (index < trainingApiOrigins.length - 1) continue;
      throw lastError;
    }
    if (!result.ok) {
      const error = new Error(data?.error || 'temporarily_unavailable');
      error.status = result.status;
      throw error;
    }
    return data;
  }
  throw lastError || new Error('training_api_unavailable');
}

export function checkoutRequestId(uid, mode) {
  const key = `chesshood:checkout:${uid}:${mode}`;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && Date.now() - saved.time < 20 * 3600000) return saved.id;
  } catch {}
  const id = crypto.randomUUID();
  try { sessionStorage.setItem(key, JSON.stringify({ id, time: Date.now() })); } catch {}
  return id;
}

export function clearCheckoutRequestIds(uid) {
  for (const mode of ['random', 'personalised', 'hood', 'lichess']) {
    try { sessionStorage.removeItem(`chesshood:checkout:${uid}:${mode}`); } catch {}
  }
}
